export const DEREGISTER_VIDEO_PLAYER = 'tru/DEREGISTER_VIDEO_PLAYER'
export const REGISTER_VIDEO_PLAYER = 'tru/REGISTER_VIDEO_PLAYER'
export const PLAY = 'tru/PLAY'
export const PAUSE = 'tru/PAUSE'

export const registerVideoPlayer = id => ({
  type: REGISTER_VIDEO_PLAYER,
  id
})

export const deregisterVideoPlayer = id => ({
  type: DEREGISTER_VIDEO_PLAYER,
  id
})

export const play = id => ({
  type: PLAY,
  id
})

export const pause = id => ({
  type: PAUSE,
  id
})



// WEBPACK FOOTER //
// ../src/actions/videoPlayerActions.js